module.exports = __webpack_public_path__ + "img/b-maps-location.123f68c0.svg";